import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import TextField from "@material-ui/core/TextField";
import CardTitle from "@saleor/components/CardTitle";
// import { ControlledCheckbox } from "@saleor/components/ControlledCheckbox";
import Grid from "@saleor/components/Grid";
import { DiscountErrorFragment } from "@saleor/fragments/types/DiscountErrorFragment";
import { ChangeEvent } from "@saleor/hooks/useForm";
import useNotifier from "@saleor/hooks/useNotifier";
import { commonMessages } from "@saleor/intl";
import { getFormErrors } from "@saleor/utils/errors";
import getDiscountErrorMessage from "@saleor/utils/errors/discounts";
import Moment from "moment";
import React, { useState } from "react";
import { useIntl } from "react-intl";

import { VoucherDetailsPageFormData } from "../VoucherDetailsPage";

interface VoucherDatesProps {
  clientErrors: {
    endDate?: string;
    endTime?: string;
    startDate?: string;
    startTime?: string;
  };
  data: VoucherDetailsPageFormData;
  defaultCurrency: string;
  disabled: boolean;
  errors: DiscountErrorFragment[];
  onChange: (event: ChangeEvent<any>) => void;
}

const VoucherDates = ({
  data,
  disabled,
  errors,
  clientErrors,
  onChange
}: VoucherDatesProps) => {
  const intl = useIntl();
  const notify = useNotifier();

  const formErrors = getFormErrors(["startDate", "endDate"], errors);

  const [hasError, setHasError] = useState(false);
  const handleDate = (
    value: any,
    dateName,
    onChange: (event: ChangeEvent<any>) => void
  ) => {
    let dateA;
    let dateB;
    let newTimeName;
    setHasError(false);
    // console.log(data.endTime);
    if (dateName === "startDate") {
      dateA = value.target.value;
      dateB = data.endDate;
      newTimeName = "startTime";
      onChange({
        target: {
          name: "startTime",
          value: "00:00"
        }
      });
    }

    if (dateName === "endDate") {
      dateA = data.startDate;
      dateB = value.target.value;
      newTimeName = "endTime";
      onChange({
        target: {
          name: "endTime",
          value: "00:00"
        }
      });
    }
    if (dateA && dateB) {
      if (dateA === dateB) {
        const datetimeA = Moment(dateA + " " + data.startTime);
        const datetimeB = Moment(dateB + " " + data.endTime);

        if (data.startTime && data.endTime && !datetimeB.isAfter(datetimeA)) {
          notify({
            status: "error",
            text: intl.formatMessage(commonMessages.timeError)
          });
          onChange({
            target: {
              name: newTimeName,
              value: ""
            }
          });
          setHasError(true);
        }
      }
    }
    if (value && !hasError) {
      onChange({
        target: {
          name: dateName,
          value: value.target.value
        }
      });
      setHasError(false);
    }
  };

  const handleTime = (
    value: any,
    timerName,
    onChange: (event: ChangeEvent<any>) => void
  ) => {
    let datetimeA;
    let datetimeB;
    setHasError(false);
    // console.log(value.target.value);
    // console.log(data.endTime);
    if (data.startDate && data.endDate) {
      if (data.startDate === data.endDate) {
        if (timerName === "startTime") {
          datetimeA = Moment(data.startDate + " " + value.target.value);
          datetimeB = Moment(data.endDate + " " + data.endTime);
        }

        if (timerName === "endTime") {
          datetimeA = Moment(data.startDate + " " + data.startTime);
          datetimeB = Moment(data.endDate + " " + value.target.value);
        }

        if (data.startTime && data.endTime && !datetimeB.isAfter(datetimeA)) {
          notify({
            status: "error",
            text: intl.formatMessage(commonMessages.timeError)
          });
          onChange({
            target: {
              name: timerName,
              value: ""
            }
          });
          setHasError(true);
        }
      }
    }
    if (value && !hasError) {
      onChange({
        target: {
          name: timerName,
          value: value.target.value
        }
      });
      setHasError(false);
    }
  };

  React.useEffect(() => {
    if (data.endDate) {
      onChange({
        target: {
          name: "endTime",
          value: "23:59"
        }
      });
    }
  }, [data.endDate]);

  return (
    <Card>
      <CardTitle
        title={intl.formatMessage({
          defaultMessage: "Active Dates",
          description: "time during voucher is active, header"
        })}
      />
      <CardContent>
        <Grid variant="uniform">
          <TextField
            id="voucherStartDateTxt"
            disabled={disabled}
            error={!!formErrors.startDate || !!clientErrors?.startDate}
            helperText={
              getDiscountErrorMessage(formErrors.startDate, intl) ||
              clientErrors?.startDate
            }
            name={"startDate" as keyof VoucherDetailsPageFormData}
            // onChange={onChange}
            onChange={value => handleDate(value, "startDate", onChange)}
            onKeyPress={event => {
              if (event.key) {
                event.preventDefault();
                event.stopPropagation();
              }
            }}
            label={intl.formatMessage(commonMessages.startDate)}
            value={data.startDate}
            type="date"
            inputProps={{
              max: data.endDate,
              min: Moment(new Date())
                // .add(1, "d")
                .format("YYYY-MM-DD")
            }}
            InputLabelProps={{
              shrink: true
            }}
            required={true}
            fullWidth
          />
          <TextField
            id="voucherStartHourTxt"
            disabled={disabled}
            error={!!formErrors.startDate || !!clientErrors?.startTime}
            helperText={
              getDiscountErrorMessage(formErrors.startDate, intl) ||
              clientErrors?.startTime
            }
            name={"startTime" as keyof VoucherDetailsPageFormData}
            // onChange={onChange}
            onChange={value => handleTime(value, "startTime", onChange)}
            onKeyPress={event => {
              if (event.key) {
                event.preventDefault();
                event.stopPropagation();
              }
            }}
            label={intl.formatMessage(commonMessages.startHour)}
            value={data.startTime}
            type="time"
            InputLabelProps={{
              shrink: true
            }}
            required={true}
            fullWidth
          />
        </Grid>
        <br />
        {/* <ControlledCheckbox
          checked={data.hasEndDate}
          label={intl.formatMessage({
            defaultMessage: "Set end date",
            description: "voucher end date, switch button"
          })}
          name={"hasEndDate" as keyof VoucherDetailsPageFormData}
          onChange={onChange}
        />
        {data.hasEndDate && ( */}
        <Grid variant="uniform">
          <TextField
            id="voucherEndDateTxt"
            disabled={disabled}
            error={!!formErrors.endDate || !!clientErrors?.endDate}
            helperText={
              getDiscountErrorMessage(formErrors.endDate, intl) ||
              clientErrors?.endDate
            }
            name={"endDate" as keyof VoucherDetailsPageFormData}
            // onChange={onChange}
            onChange={value => handleDate(value, "endDate", onChange)}
            onKeyPress={event => {
              if (event.key) {
                event.preventDefault();
                event.stopPropagation();
              }
            }}
            label={intl.formatMessage(commonMessages.endDate)}
            value={data.endDate}
            inputProps={{
              min: data.startDate
                ? data.startDate
                : Moment(new Date())
                    .add(1, "d")
                    .format("YYYY-MM-DD")
            }}
            type="date"
            InputLabelProps={{
              shrink: true
            }}
            required={true}
            fullWidth
          />
          <TextField
            id="voucherEndHourTxt"
            disabled={disabled}
            error={!!formErrors.endDate || !!clientErrors?.endTime}
            helperText={
              getDiscountErrorMessage(formErrors.endDate, intl) ||
              clientErrors?.endTime
            }
            name={"endTime" as keyof VoucherDetailsPageFormData}
            // onChange={onChange}
            onChange={value => handleTime(value, "endTime", onChange)}
            onKeyPress={event => {
              if (event.key) {
                event.preventDefault();
                event.stopPropagation();
              }
            }}
            label={intl.formatMessage(commonMessages.endHour)}
            value={data.endTime}
            type="time"
            InputLabelProps={{
              shrink: true
            }}
            required={true}
            fullWidth
          />
        </Grid>
        {/* )} */}
      </CardContent>
    </Card>
  );
};
export default VoucherDates;
